import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { PageSection, Profile, QUERY_KEYS } from '@24i/nxg-sdk-photon';
import { log } from '@24i/nxg-core-utils/src/logger';

import { useFirebase } from '../../../context/Firebase';
import { useContentData } from '../../../context/ContentData';

const useSectionsStructureQuery = (pageId?: string, selectedProfile?: Profile | null) => {
    const { i18n } = useTranslation();
    const { language } = i18n;
    const { fetchPage } = useContentData();
    const { recordError } = useFirebase();

    return useQuery<PageSection[]>(
        [QUERY_KEYS.sectionsStructure, pageId, selectedProfile?.id, language],
        () => fetchPage(pageId),
        {
            enabled: !!pageId,
            refetchOnMount: true,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            onError: (error) => {
                log(error);
                recordError?.(error);
            },
        }
    );
};

export default useSectionsStructureQuery;
